module.exports = __webpack_public_path__ + "img/1199.ccf90442.gif";